<!-- month-calendar.html -->
<div class="month-calendar">
  <div class="calendar-header">
    <div class="month-navigation">
      <button class="nav-button" (click)="previousMonth()">
        <img src="assets/icons/arrowBack.png" alt="Mês anterior" class="nav-icon">
      </button>

      <h2 class="month-title">{{ currentMonthYear }}</h2>

      <button class="nav-button" (click)="nextMonth()">
        <img src="assets/icons/arrowNext.png" alt="Próximo mês" class="nav-icon">
      </button>
    </div>
  </div>

  <!-- Estados de loading/error -->
  <div class="loading-state" *ngIf="isLoading">
    <div class="spinner"></div>
    <p>Carregando agendamentos...</p>
  </div>

  <div class="error-state" *ngIf="error && !isLoading">
    <div class="error-icon">⚠️</div>
    <p>Erro ao carregar agendamentos</p>
    <button class="retry-button" (click)="loadAppointments()">Tentar novamente</button>
  </div>

  <div class="calendar-wrapper" *ngIf="!isLoading && !error">
    <div class="weekdays-header">
      <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
    </div>

    <div class="calendar-grid">
      <div *ngFor="let day of calendarDays"
           class="calendar-day"
           [class.empty-day]="!day.isCurrentMonth"
           [class.today]="day.isToday"
           [class.has-appointments]="day.appointments && day.appointments.length > 0">

        <div class="day-number">{{ day.date.getDate() }}</div>

        <div class="appointments-container" *ngIf="day.appointments && day.appointments.length > 0">
          <!-- NOVO LAYOUT com bolinha -->
          <div class="appointment-item"
               *ngFor="let appointment of day.displayAppointments; let i = index"
               (click)="openDayDetails(day)">
            <div class="appointment-bullet" [style.background-color]="getAppointmentColor(i)"></div>
            <div class="appointment-info">
              <div class="appointment-name">{{ appointment.time }} - {{ appointment.clientName }}</div>
            </div>
          </div>

          <div *ngIf="day.hasMoreAppointments"
               class="more-appointments"
               (click)="openDayDetails(day)">
            +{{ day.totalAppointments - 4 }} leads
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div *ngIf="selectedDay" class="modal-overlay" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ getFormattedDateExtenso(selectedDay.date) }}</h3>
        <button class="close-button" (click)="closeModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div *ngIf="selectedDay.appointments.length === 0" class="no-appointments">
          Nenhum agendamento para este dia
        </div>
        <div class="appointments-list-modal" *ngIf="selectedDay.appointments.length > 0">
          <!-- ALTERADO: Adicionado (click) para navegar -->
          <div class="appointment-modal-row"
               *ngFor="let appointment of selectedDay.appointments; let i = index"
               (click)="navigateToLeadDetails(appointment.leadId)"
               style="cursor: pointer;"> <!-- Adicionado cursor pointer -->
            <div class="appointment-modal-bullet" [style.background-color]="getAppointmentColor(i)"></div>
            <div class="appointment-modal-name">{{ appointment.fullName || appointment.clientName }}</div>
            <div class="appointment-modal-time">{{ appointment.time }}</div>
            <div class="appointment-modal-vendedor">
              Vendedor: <span class="vendedor-nome">{{ appointment.vendedor || 'Não informado' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
